<script>
import { InteractiveVideo } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  extends: FormMixin,
  data() {
    return {
      form: {},
      redirectRoute: { name: 'InteractiveVideo List' }
    }
  },
  computed: {
    service() {
      return InteractiveVideo
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Slug',
          disabled: !!this.slug,
          modelPath: [this, 'form', 'slug']
        }),
        new fields.Input({
          label: 'Nazwa',
          modelPath: [this, 'form', 'name']
        }),
        new fields.JsonEditor({
          label: 'Dane (JSON)',
          modelPath: [this, 'form', 'data']
        })
      ]
    }
  }
}
</script>
